import React, { useState, useEffect } from 'react';
import { MenuItem, FormControl, Select } from '@mui/material';
import moment from 'moment-timezone';

const Timezone = ({ handleTimezoneChange, timeZoneValue }) => {
  const [timezones, setTimezones] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState('');

  useEffect(() => {
    // Fetch the list of timezones using moment-timezone
    const fetchedTimezones = moment.tz.names();
    setTimezones(fetchedTimezones);

    // Set the selected timezone - handle null/undefined values
    if (timeZoneValue) {
      setSelectedTimezone(timeZoneValue);
    } else {
      // Auto-detect user's timezone as fallback
      const detectedTimezone = moment.tz.guess();
      setSelectedTimezone(detectedTimezone);
      // Optionally trigger the parent handler with detected timezone
      // handleTimezoneChange({ target: { value: detectedTimezone } });
    }
  }, [timeZoneValue]);

  const handleSelectChange = (e) => {
    const selected = e.target.value;
    setSelectedTimezone(selected);
    handleTimezoneChange(e);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 200, fontSize: 20 }} size="medium">
      <Select
        sx={{
          color: 'var(--theme-text)',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--theme-border)' },
          '& .MuiSelect-icon': { color: 'var(--theme-text)' },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: 'var(--theme-bg-elevated)',
              color: 'var(--theme-text)',
              '& .MuiMenuItem-root:hover': { backgroundColor: 'var(--theme-border)' },
            },
          },
        }}
        value={selectedTimezone}
        onChange={handleSelectChange}
        displayEmpty
      >
        {timezones.map((timezone) => (
          <MenuItem key={timezone} value={timezone}>
            {timezone}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Timezone;